import { useMemo } from 'react'
import {
  APPOINTMENT_TIME_OPTIONS,
  combineLocalDateTime,
  formatLocalDateValue,
  formatLocalTimeValue,
} from '../../utils/appointmentDateTime'
import { DateInput } from './Form'
import { Select } from './Form'
import { cx } from './utils'

type ControlSize = 'sm' | 'md' | 'lg'

export type DateTimeInputProps = {
  id: string
  value: Date | null
  onChange: (value: Date | null) => void
  controlSize?: ControlSize
  disabled?: boolean
  className?: string
  timePlaceholder?: string
}

export function DateTimeInput({
  id,
  value,
  onChange,
  controlSize = 'md',
  disabled = false,
  className,
  timePlaceholder = 'Επίλεξε ώρα…',
}: DateTimeInputProps) {
  const dateValue = value ? formatLocalDateValue(value) : ''
  const timeValue = value ? formatLocalTimeValue(value) : ''

  const timeOptions = useMemo(() => APPOINTMENT_TIME_OPTIONS, [])

  function emit(nextDate: string, nextTime: string) {
    if (!nextDate || !nextTime) {
      onChange(null)
      return
    }
    onChange(combineLocalDateTime(nextDate, nextTime))
  }

  function handleDateChange(nextDate: string) {
    if (!nextDate) {
      onChange(null)
      return
    }
    emit(nextDate, timeValue || timeOptions[0]?.value || '')
  }

  function handleTimeChange(nextTime: string) {
    if (!dateValue) return
    emit(dateValue, nextTime)
  }

  return (
    <div
      className={cx('grid gap-3 sm:grid-cols-[minmax(0,1.2fr)_minmax(0,0.8fr)]', className)}
      role="group"
      aria-labelledby={id}
    >
      <DateInput
        id={`${id}-date`}
        value={dateValue}
        onChange={handleDateChange}
        controlSize={controlSize}
        disabled={disabled}
        clearLabel="Καθαρισμός ημερομηνίας"
      />
      <Select
        id={`${id}-time`}
        value={timeValue}
        onChange={(e) => handleTimeChange(e.target.value)}
        controlSize={controlSize}
        disabled={disabled || !dateValue}
        aria-label="Ώρα"
      >
        <option value="">{timePlaceholder}</option>
        {timeOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </div>
  )
}
